module.exports = __webpack_public_path__ + "img/kjarstad_Erobreren1.30faebb6.jpg";